export default __webpack_public_path__ + "static/media/Isadora.482e7841.jpg";